/* Requires: twitterFetcher.js */
/* Requires: jquery.scrollify.js */

var GetTweetsHub = (function($) {
    var self = this;

    var init = function() {

      var config4 = {
				"profile": {"screenName": 'Space_Zer0'},
	      "domId": 'jstweethub',
	      "maxTweets": 1,
	      "enableLinks": true,
	      "showUser": false,
	      "showTime": true,
	      "showRetweet": false,
	      "showInteraction": false
      };
      function dateFormatter(date) {
        return date.toTimeString();
      }

      twitterFetcher.fetch(config4);
    };

     return {
        init: init
    };

})(jQuery);

$(document).ready(function($) {
    GetTweetsHub.init();
});
